<ion-content class="modal-options ion-padding">
  @if (hasPendingEditPetition) {
  <div class="edit-petition-warning">
    <div class="image-wrapper">
      <img
        src="assets/images/scanner-result-warning.svg"
        class="icon-animation"
        alt="Advertencia"
      />
    </div>
    <p class="title">
      {{ "edit-ticket-modal.pending-edit-title" | translate }}
    </p>
    <p class="warning-message">
      {{ "edit-ticket-modal.pending-edit" | translate }}
    </p>
  </div>
  } @else {
  <div class="modal-form-container">
    <div class="content-top">
      <h3 class="title font-heavitas">{{ ticket.product.name }}</h3>
      @if (shouldShowReference()) {
      <p class="reference">
        {{ ticket.reference }}
      </p>
      }
      <p class="price">{{ getTicketAmount(ticket) | arsCurrency }}</p>
      <!-- Alert -->
      <app-info-alert
        [message]="'edit-ticket-modal.alert' | translate"
        type="warning"
      />
      <!-- Form -->
      <div class="message-container">
        <app-reason-textarea [control]="reasonControl" />
      </div>
      <div class="quote-container">
        <app-quantity-selector
          [value]="quantity()"
          (valueChange)="quantity.set($event)"
          [min]="1"
          [max]="10"
          [label]="'edit-ticket-modal.form.quantity-label' | translate"
        />
      </div>
    </div>
    <!-- Buttons -->
    <div class="buttons-bottom">
      <app-main-button
        [label]="'edit-ticket-modal.send'"
        (clicked)="onSubmitEditPetition()"
      />
    </div>
  </div>
  }
</ion-content>
